import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagMK = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M28.802 49.711a24.865 24.865 0 0 0 10.982-4.552L25 24.999l3.802 24.712ZM21.198.287a24.868 24.868 0 0 0-10.982 4.552L25 24.999 21.198.287Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M10.216 45.159a24.869 24.869 0 0 0 10.982 4.553L25 24.998l-14.784 20.16Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M4.84 10.215A24.868 24.868 0 0 0 .288 21.197L25 25 4.84 10.215Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M.288 28.8A24.866 24.866 0 0 0 4.84 39.784L25 24.999.288 28.8ZM49.713 21.197a24.869 24.869 0 0 0-4.553-10.982L25 25l24.713-3.802ZM39.784 4.839A24.868 24.868 0 0 0 28.802.287L25 24.999 39.784 4.84Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M45.16 39.783A24.871 24.871 0 0 0 49.713 28.8L25 24.999l20.16 14.784Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M25 33.694a8.696 8.696 0 1 0 0-17.39 8.696 8.696 0 0 0 0 17.39Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M25 31.522a6.522 6.522 0 1 0 0-13.043 6.522 6.522 0 0 0 0 13.043Z"
}));
FlagMK.displayName = 'FlagMK';
export default withFlagWrapper(FlagMK);
//# sourceMappingURL=index.js.map